<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Contract_Num">Policy #</label>
              <input
                myFocus
                type="text"
                name="Contract_Num"
                [(ngModel)]="dsCollection.criteria.Contract_Num"
                ngControl="Contract_Num"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Consumer">Consumer</label>
              <ep-inline-search
                [noLabel]="true"
                class="w-100"
                name="Consumer"
                [desc]="consumerModel.consumerName"
                [(ngModel)]="consumerModel.consumerID"
                [descFormControlPath]="'consumerModel.consumerName'"
                [formControlPath]="'consumerModel.consumerID'"
                [objectType]="'entity'"
                [placeholder]="'Select Consumer'"
                [isStandalone]="true"
                [options]="{ autoSearch: false, allowClear: true }"
                [criteria]="{ Role_Type: 'CN' }"
                (dataSelected)="setConsumer($event)"
                (dataCleared)="clearConsumer()"
              >
              </ep-inline-search>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              type="button"
              (click)="dsCollection.criteria.Contract_Num = ''; model.dirty = true"
              classes="secondary"
              style="float: right; margin-top: 16px"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #contractFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th style="min-width: 150px">Entity Name</th>
              <th style="min-width: 150px">Contract Number</th>
              <th style="min-width: 150px">Status</th>
              <th style="min-width: 150px">Sched Cancel</th>
              <th style="min-width: 150px">Revision</th>
              <th style="min-width: 150px">Revision Eff</th>
              <th style="min-width: 150px">Revision Exp</th>
              <th style="min-width: 150px">LOB</th>
              <th style="min-width: 150px">Supplier</th>
              <th style="min-width: 150px">Effective</th>
              <th style="min-width: 150px">Expiration</th>
              <th style="min-width: 150px">Binder Num</th>
              <th style="min-width: 150px">Binder Eff</th>
              <th style="min-width: 150px">Binder Exp</th>
              <th style="min-width: 150px">Contract Set</th>
              <th style="min-width: 150px">Option Desc</th>
            </tr>
            <tr
              *ngFor="
                let contract of dsCollection.objectNodes
                  | epFilter : contractFilter.filter : contractFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(contract)"
            >
              <td>
                {{ contract.Consumer.Entity_Name }}
              </td>
              <td>
                {{ contract.Contract_Num }}
              </td>
              <td>
                {{ contract.Last_Status_Desc }}
              </td>
              <td>
                {{ contract.Scheduled_Cancel_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Revision_Num }}
              </td>
              <td>
                {{ contract.Revision_Eff_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Revision_Exp_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Line_Code }}
              </td>
              <td>
                {{ contract.Supplier.Entity_Name }}
              </td>
              <td>
                {{ contract.Eff_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Exp_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Binder_Num }}
              </td>
              <td>
                {{ contract.Binder_Eff_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Binder_Exp_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ contract.Contract_Set_ID }}
              </td>
              <td>
                {{ contract.Option_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Policies</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
